<template>
    <div>
        <b-list-group>
            <b-card>
                    <div v-if="!tags.length" class="alert alert-info">Esta tarea no tiene etiquetas</div>
                    <div v-else class="card-text">
                        <b-list-group-item  class="d-flex align-items-center">
                            <b-badge class="mx-2" v-for="(tag, i) in tags" :key="i" variant="primary" pill>{{tag.tag}}</b-badge>
                        </b-list-group-item>
                    </div>
            </b-card>
            
        </b-list-group>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            default: []
        }
    },
}
</script>
